import {
  ClearIndicatorProps,
  GroupBase,
  SelectComponentsConfig,
  components as ReactSelectComponents,
} from 'react-select';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';

import styles from '../select.module.scss';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  ownProps: ClearIndicatorProps<SOption, IsMulti, Group>,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  showClearIndicator?: boolean,
}

const ClearIndicator = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  ownProps,
  components = {},
  showClearIndicator,
}: IProps<SOption, IsMulti, Group>) => {
  if (components?.ClearIndicator) {
    const { ClearIndicator: ClearIndicatorComponent } = components;

    return <ClearIndicatorComponent { ...ownProps } />;
  }

  if (!showClearIndicator) {
    return null;
  }

  return (
    <ReactSelectComponents.ClearIndicator { ...ownProps }>
      <div className={ styles.clearIndicator } data-test="clearAccount">
        <IconClose />
      </div>
    </ReactSelectComponents.ClearIndicator>
  );
};

export default ClearIndicator;
